import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';


const styles = (theme) => ({
  testimonial: {
    margin: '0 auto',
    background: theme.palette.secondary.main,
    maxWidth: 480,
    minWidth: 300,
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 2.5}px`,
    [theme.breakpoints.up(400)]: {
      minWidth: 320,
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 2.5}px`,
    },
    [theme.breakpoints.up(1280)]: {
      padding: `${theme.spacing.unit * 4}px ${theme.spacing.unit * 5}px`,
    },
    height: '100%',
  },
  name: {
    ...theme.typography.hg36r(theme),
    marginBottom: theme.spacing.unit * 1,
  },
  title: {
    ...theme.typography.hg18ru(theme),
    color: theme.palette.primary.main,
    marginBottom: theme.spacing.unit * 2,
  },
  brief: {
    ...theme.typography.hg18r(theme),
  },
});


function Testimonial(props) {
  const {
    className = null,
    classes,
    name,
    title,
    brief,
    ...otherProps,
  } = props;

  return (
    <div className={classNames(
      classes.testimonial,
      className
    )} {...otherProps}>
      <div className={classes.name}>{name}</div>
      <div className={classes.title}>{title}</div>
      <div className={classes.brief}>{brief}</div>
    </div>
  );
}

export default withStyles(styles)(Testimonial);



// WEBPACK FOOTER //
// ./src/parts/Testimonial.js